// containers/CardExperienceSorterContainer.tsx
import React, { useRef, useEffect, useCallback, useState } from 'react';
import { Observer } from 'mobx-react';
import { DndContext, closestCenter, PointerSensor, useSensor, useSensors, } from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { useVirtualizer } from '@tanstack/react-virtual';
import CardOrderStore from '../Store';
import { SortableRow } from './SortableRow';
import { reaction } from 'mobx';
import './CardExperienceSorter.css';
var ROW_HEIGHT = 56;
export default function CardExperienceSorterContainer(_a) {
    var clientId = _a.clientId, apiBase = _a.apiBase;
    // el store vive en un ref para que sobreviva a los re-renders del contenedor
    // sin necesidad de que el contenedor sea @observer
    var storeRef = useRef(null);
    if (!storeRef.current) {
        storeRef.current = new CardOrderStore();
    }
    var store = storeRef.current;
    var parentRef = useRef(null);
    // fuerza al contenedor a re-renderizar cuando cambia la cantidad de cards,
    // para que useVirtualizer recalcule su `count` con el valor real
    var _b = useState(0), forceRender = _b[1];
    useEffect(function () {
        var dispose = reaction(function () { return store.cards.length; }, function () { return forceRender(function (n) { return n + 1; }); });
        return dispose;
    }, [store]);
    useEffect(function () {
        store.load();
    }, [store]);
    var sensors = useSensors(useSensor(PointerSensor, {
        activationConstraint: { distance: 5 },
    }));
    var rowVirtualizer = useVirtualizer({
        count: store.cards.length,
        getScrollElement: function () { return parentRef.current; },
        estimateSize: function () { return ROW_HEIGHT; },
        overscan: 10,
    });
    var handleDragEnd = useCallback(function (event) {
        var active = event.active, over = event.over;
        if (!over || active.id === over.id)
            return;
        var fromIndex = store.cards.findIndex(function (c) { return c.id === active.id; });
        var toIndex = store.cards.findIndex(function (c) { return c.id === over.id; });
        if (fromIndex === -1 || toIndex === -1)
            return;
        store.reorder(fromIndex, toIndex);
    }, [store]);
    var handleMoveToPosition = useCallback(function (cardId, targetPosition) {
        var toIndex = store.moveToPosition(cardId, targetPosition);
        if (toIndex !== -1) {
            requestAnimationFrame(function () {
                rowVirtualizer.scrollToIndex(toIndex, { align: 'center' });
            });
        }
    }, [store, rowVirtualizer]);
    console.log('store.cards: ', store.cards);
    return (React.createElement("div", { className: "card-sorter" },
        React.createElement(Observer, null, function () { return store.loading ? React.createElement("div", null, "Cargando\u2026") : null; }),
        React.createElement(DndContext, { sensors: sensors, collisionDetection: closestCenter, onDragEnd: handleDragEnd },
            React.createElement(Observer, null, function () { return (React.createElement(SortableContext, { items: store.cards.map(function (c) { return c.id; }), strategy: verticalListSortingStrategy },
                React.createElement("div", { ref: parentRef, style: { height: '100%', overflow: 'auto', position: 'relative' } },
                    React.createElement("div", { style: { height: rowVirtualizer.getTotalSize(), position: 'relative' } }, rowVirtualizer.getVirtualItems().map(function (virtualRow) {
                        console.log('virtualRow', virtualRow);
                        var card = store.cards[virtualRow.index];
                        if (!card)
                            return null;
                        return (React.createElement(SortableRow, { key: card.id, card: card, virtualStart: virtualRow.start, totalCount: store.cards.length, onMoveToPosition: handleMoveToPosition }));
                    }))))); })),
        React.createElement(Observer, null, function () { return (React.createElement("button", { onClick: store.save, disabled: !store.dirty || store.saving }, store.saving ? 'Guardando…' : 'Guardar orden')); })));
}



//////////////////
// WEBPACK FOOTER
// ./src/modules/CardExperiences/container/CardExperienceSorterContainer.tsx
// module id = 1620
// module chunks = 0